import { createExportExcelService } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";

export const exportWebsitesToExcelService = createExportExcelService("websites");
export const exportContactsToExcelService = createExportExcelService("contacts");

export const exportLeadsToExcelService = {
    [LeadsType.Websites]: exportWebsitesToExcelService,
    [LeadsType.Companies]: createExportExcelService("companies"),
};
